export default {
  subject: 'asunto',
  email: 'correo electrónico',
  name: 'nombres',
  message: 'mensaje',
  password: 'contraseña',
  repeatPassword: 'repetir contraseña',
  username: 'nombre de usuario',
  country: 'país',
  console: 'consola',
  position: 'posición',
  newPassword: 'contraseña nueva',
  passwordConfirmation: 'confirmar contraseña nueva',
  title: 'título',
  idOrUsername: 'id o nombre de usuario',
  period: 'periodo',
  description: 'descripción',
  videoCode: 'código del video',
  order: 'Orden',
  type: 'tipo',
  teamDowns: 'Número de equipos que se van a la baja',
  teamLiguilla: 'Número de equipos que pasan a la liguilla',
  cardNumber: 'número de tarjeta',
  expirationDate: 'fecha de expiración',
  cardMonth: 'mes',
  cardYear: 'año',
}
